import React from 'react';
import Plot from 'react-plotly.js';
import { useFetchOption } from '../hooks/useFetchOption';
import { useGetFillValue } from '../hooks/useGetFillValue';

const DoubleNumericChart = ({ geoserverUrl, map1LayerName, map1Data, map1LegendData, map2LayerName, map2Data, map2LegendData, map1Option, map2Option }) => {
  
  const map1ValueData = useFetchOption(geoserverUrl, map1LayerName, map1Data.variable, map1Option);
  const map2ValueData = useFetchOption(geoserverUrl, map2LayerName, map2Data.variable, map2Option);

  const map1ChartProps = useGetFillValue(map1LegendData, map1Data.variable, map1ValueData )
  const map2ChartProps = useGetFillValue(map2LegendData, map2Data.variable, map2ValueData )
  
  if (map1ValueData !== '' && map2ValueData !== '' && map1ChartProps !== '' && map2ChartProps !== '') {

if(map1ValueData < 0 || map2ValueData < 0)
  {
    const mapValueData = (map1ValueData > map2ValueData) ? map1ValueData : map2ValueData
    const mapOption = (map1ValueData > map2ValueData) ? map1Option : map2Option
    const mapChartProps = (map1ValueData > map2ValueData) ? map1ChartProps : map2ChartProps
    const mapData = (map1ValueData > map2ValueData) ? map1Data : map2Data
    const mapLayerName = (map1ValueData > map2ValueData) ? map1LayerName : map2LayerName

    return (
      <div className="chart-container">
      <div style={{ 
        borderBottom: '4px solid blue', 
        width: '100%',
        borderBottomColor: 'blue', // Solo se aplica color al borde inferior
        borderBottomWidth: '2px', // Se establece el ancho del borde inferior
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)' // Añadida sombra
        }}>
      <Plot
        data={[
          {
            x: [''],
            y: [mapValueData],
            type: 'bar',
            name: mapOption.slice(0,15),
            yaxis: 'y1',
            marker: { color: mapChartProps.fill },
            offsetgroup: 'A', // Grupo para las barras de Variable 1
            hovertemplate: `%{y:,.2f} ${mapData.unit}` 
          }
        ]}
        layout={{
          barmode: 'group',
          bargap: 0.2, // Espacio entre las barras
          yaxis: {
            title: mapLayerName, 
            side: 'left',
            range: [0, mapChartProps.maxLimit], 
            // tickformat: ',.2f' 
           },
          showlegend: false,
          autosize: true, // Ajuste automático del tamaño
          margin: {
            t: 10, // Ajuste de la altura del título
            b: 20 
          }
        }}
        config={{ displayModeBar: false }}
        style={{ width: '100%', height: '100%' }}
      />
      </div></div>
    );
  }

  return (
    <div className="chart-container">
    <div style={{ 
      borderBottom: '4px solid blue', 
      width: '100%',
      borderBottomColor: 'blue', // Solo se aplica color al borde inferior
      borderBottomWidth: '2px', // Se establece el ancho del borde inferior
      boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)' // Añadida sombra
      }}>
    <Plot
      data={[
        {
          x: [''],
          y: [map1ValueData],
          type: 'bar',
          name: map1Option.slice(0,15),
          yaxis: 'y1',
          marker: { color: map1ChartProps.fill },
          offsetgroup: 'A', // Grupo para las barras de Variable 1
          hovertemplate: `%{y:,.2f} ${map1Data.unit}` 
        },
        {
          x: [''],
          y: [map2ValueData],
          type: 'bar',
          name: map2Option.slice(0,15),
          yaxis: 'y2',
          marker: { color: map2ChartProps.fill },
          offsetgroup: 'B', // Grupo para las barras de Variable 2
          hovertemplate: `%{y:,.2f} ${map2Data.unit}`
        }
      ]}
      layout={{
        barmode: 'group',
        bargap: 0.2, // Espacio entre las barras
        yaxis: {
          title: map1LayerName, 
          side: 'left',
          range: [0, map1ChartProps.maxLimit], 
          // tickformat: ',.2f' 
         },
        yaxis2: {
          title: map2LayerName,
          overlaying: 'y',
          side: 'right',
          range: [0, map2ChartProps.maxLimit],
          // tickformat: ',.2f' 
        },
        showlegend: false,
        autosize: true, // Ajuste automático del tamaño
        margin: {
          t: 10, // Ajuste de la altura del título
          b: 20 
        }
      }}
      config={{ displayModeBar: false }}
      style={{ width: '100%', height: '100%' }}
    />
    </div></div>
  );
}
};

export default DoubleNumericChart;
